// @react-functional

import React from 'react';
import { useModal } from '../../../components/modal/useModal';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { CommentaryDecisionSourcesModal } from './CommentaryDecisionSourcesModal';
import { CommentarySourceType } from '../../commentary.types';

type Props = {
  source: string;
  commentaryId: string;
};

export const useCommentaryDecisionSourcesModal = ({
  source,
  commentaryId,
}: Props) => {
  const { openModal } = useModal(
    (modalProps) => (
      <CommentaryDecisionSourcesModal
        source={source}
        {...modalProps}
        commentaryId={commentaryId}
      />
    ),
    [commentaryId, source],
  );
  return () => {
    doctrineAnalytics('Search ModalCommentarySourcesOpened', {
      source,
      commentaryId,
      type: CommentarySourceType.DECISION,
    });
    openModal();
  };
};
